// DS: IL5.7
import React from 'react';

export interface Props {
  size?: number;
}

const BoostIllustration: React.FC<Props> = ({ size = 96 }) => {
  return (
    <img
      width={size}
      src="//st.deviantart.net/eclipse/illustrations/boost-deviation.png"
      alt="rocket flying in space"
    />
  );
};
BoostIllustration.displayName = 'BoostIllustration';

export default BoostIllustration;
